<div
  *ngIf="!isDefaultView"
  class="call-layout-wrapper"
  [class.transcript-main-layout]="isTranscriptMain"
>
  <div class="main-box-wrapper">
    <div class="main-box">
      <div class="box-content-wrapper">
        <!-- Agent in main -->
        <app-interview-ai-view
          *ngIf="isAgentInMain"
          class="fade-scale-animation"
        ></app-interview-ai-view>

        <!-- Transcript in main -->
        <app-interview-transcript
          *ngIf="isTranscriptMain"
          [transcriptsArray]="displayedTranscript"
          [hide]="hideTranscription"
          [isMaximized]="false"
          [showDocumentLoader]="isDocumentProcessing"
          [loaderLogoSrc]="commonService.Images.IQIGAI_LOGO"
          (messageSend)="handleSendMessage($event)"
          class="fade-scale-animation"
        ></app-interview-transcript>
      </div>
    </div>

    <!-- ACTION BUTTONS -->
    <div class="actions-panel">
      <div class="action-btns-wrapper">
        <!-- Microphone -->
        <div class="action-item">
          <div
            (click)="handleMicBtn()"
            class="action-btn"
            [class.offState]="isMuted"
          >
            <img
              [src]="
                isMuted
                  ? commonService.Images.MICROPHONE_OFF_ICON
                  : commonService.Images.MICROPHONE_ICON
              "
            />
          </div>
          <p class="text-xs poppinsMedium mt-1">Microphone</p>
        </div>

        <!-- Resize -->
        <div class="action-item">
          <div (click)="handleMinimizeCurrentSection()" class="action-btn">
            <img [src]="commonService.Images.MINIMIZE_LAYOUT_ICON" />
          </div>
          <p class="text-xs poppinsMedium mt-1">Resize</p>
        </div>

        <!-- Transcript -->
        <div class="action-item">
          <div
            (click)="handleTranscription()"
            class="action-btn"
            [class.offState]="hideTranscription"
          >
            <img
              [src]="
                hideTranscription
                  ? commonService.Images.HIDE_TRANSCRIPT
                  : commonService.Images.TRANSCRIPT
              "
            />
          </div>
          <p class="text-xs poppinsMedium mt-1">Transcript</p>
        </div>

        <div class="action-item">
          <div class="action-btn" (click)="fileInput.click()">
            <img [src]="commonService.Images.FILE_IMAGE_STAFFING" />
          </div>

          <p class="text-xs poppinsMedium mt-1">Attach</p>

          <input
            #fileInput
            type="file"
            hidden
            accept=".pdf,.doc,.docx"
            (change)="onFileSelected($event)"
          />
        </div>

        <div class="action-item">
          <div class="action-btn end-call-btn" (click)="onCallEnd()">
            <img [src]="commonService.Images.END_CALL_ICON" />
          </div>
          <p class="text-xs poppinsMedium mt-1">End</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ✅ RIGHT SIDE - AI VIEW OR TRANSCRIPT -->
  <div class="right-panel">
    <div class="layout-maximize" (click)="handleLayout('MEDIUM')">
      <img [src]="commonService.Images.MAXIMIZE_LAYOUT_ICON" />
    </div>

    <div class="box-content-wrapper">
      <!-- AI View in right panel -->
      <app-interview-ai-view
        *ngIf="isTranscriptMain"
        class="fade-scale-animation"
      ></app-interview-ai-view>

      <!-- Transcript in right panel -->
      <app-interview-transcript
        *ngIf="isAgentInMain"
        [transcriptsArray]="displayedTranscript"
        [hide]="hideTranscription"
        [showDocumentLoader]="isDocumentProcessing"
        [loaderLogoSrc]="commonService.Images.IQIGAI_LOGO"
        (messageSend)="handleSendMessage($event)"
        class="fade-scale-animation"
      ></app-interview-transcript>
    </div>
  </div>

</div>

<!-- ✅ DEFAULT VIEW -->
<div *ngIf="isDefaultView" class="default-layout">
  <!-- LEFT PANEL -->
  <div class="chat-history-panel">
    <div class="chat-header">Chat history</div>

    <div class="new-chat-box" (click)="showCallLayout()">
      <div class="plus-btn">+</div>
    </div>

    <!-- Loading state while chat history is being fetched -->
    <div *ngIf="isHistoryLoading" class="history-loading-state">
      <img [src]="commonService.Images.IQIGAI_LOGO" class="history-loading-logo" alt="IQIGai Logo" />
      <p class="history-loading-text">Fetching older chats...</p>
    </div>

    <div *ngIf="!isHistoryLoading" class="empty-state">Create new chats to access it in chat history</div>
  </div>

  <!-- RIGHT PANEL -->
  <div class="default-main-box">
    <div class="ai-wrapper">
      <app-interview-ai-view
        class="fade-scale-animation"
      ></app-interview-ai-view>
    </div>
  </div>
</div>
